import LogoutIcon from '@mui/icons-material/Logout';
// import NightlightOutlinedIcon from '@mui/icons-material/NightlightOutlined';
// import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
// import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { TrackCover } from 'components/track/TrackCover';
import { useUser } from 'hooks/useUser';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';

export function AccountMenu() {
  const { t } = useTranslation();
  const theme = useTheme();
  const isExtremelySmallScreen = useMediaQuery('(max-width:300px)');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const userContext = useUser();

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    userContext.setUser(null);
  };

  // return (
  //   <ActionMenu
  //     action={
  //       <IconButton onClick={handleOpenMenu} sx={{ p: 0 }}>
  //         <Avatar>
  //           <PersonIcon />
  //         </Avatar>
  //       </IconButton>
  //     }
  //     menuProps={{
  //       anchorOrigin: {
  //         vertical: 'top',
  //         horizontal: 'right',
  //       },
  //       keepMounted: true,
  //       transformOrigin: {
  //         vertical: 'top',
  //         horizontal: 'right',
  //       },
  //     }}
  //   >
  //     {/* <MenuItem disabled>
  //          <ListItemIcon>
  //            <NightlightOutlinedIcon fontSize="small" />
  //          </ListItemIcon>
  //          <ListItemText>
  //            Dark Mode (soon)
  //            <Switch
  //              // TODO: Change mode change in user context
  //              // onChange={}
  //              checked={theme.palette.mode == 'dark'}
  //            />
  //          </ListItemText>
  //        </MenuItem>
  //        <Divider /> */}
  //     <MenuItem onClick={handleLogout}>
  //       <ListItemIcon>
  //         <LogoutIcon fontSize="small" />
  //       </ListItemIcon>
  //       <ListItemText>Logout</ListItemText>
  //     </MenuItem>
  //   </ActionMenu>
  // );

  return (
    <>
      <IconButton onClick={handleOpenMenu} sx={{ p: 0 }}>
        <Avatar sx={{ width: isExtremelySmallScreen ? 24 : 32, height: isExtremelySmallScreen ? 24 : 32 }}>
          <TrackCover
            title={userContext.user?.displayName || userContext.user?.email || ''}
            cover={userContext.safePhoto || undefined}
            size="small"
          />
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          mt: '45px',
        }}
      >
        {/* <MenuItem disabled>
          <ListItemIcon>
            <NightlightOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            Dark Mode (soon)
            <Switch
              // TODO: Change mode change in user context
              // onChange={}
              checked={theme.palette.mode == 'dark'}
            />
          </ListItemText>
        </MenuItem>
         */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: 'start',
            alignItems: 'center',
            px: 2,
            py: 1,
            ml: -0.5,
          }}
        >
          <Avatar
            sx={{
              width: 40,
              height: 40,
              mr: 2,
            }}
          >
            <TrackCover
              title={userContext.user?.displayName || userContext.user?.email || ''}
              cover={userContext.safePhoto || undefined}
            />
          </Avatar>
          <Box>
            <Typography sx={{ flex: '1 1 auto', lineHeight: 1 }}>
              {userContext.user?.displayName || userContext.user?.email}
            </Typography>
          </Box>
        </Stack>
        <Divider variant="middle" sx={{ my: 1 }} />
        {/* <MenuItem component={Link} to="/profile" onClick={handleCloseMenu}>
          <ListItemIcon>
            <PersonOutlinedIcon />
          </ListItemIcon>
          <ListItemText>Profile</ListItemText>
        </MenuItem>
        <MenuItem component={Link} to="/subscription" onClick={handleCloseMenu}>
          <ListItemIcon>
            <StarBorderOutlinedIcon />
          </ListItemIcon>
          <ListItemText>Subscription</ListItemText>
        </MenuItem> */}
        <MenuItem component={Link} to="/settings" onClick={handleCloseMenu}>
          <ListItemIcon>
            <SettingsOutlinedIcon />
          </ListItemIcon>
          <ListItemText>{t('settings', 'Settings')}</ListItemText>
        </MenuItem>
        <Divider variant="middle" />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText>{t('logout', 'Logout')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
